const subMenuItems = {
  notAuth: [
    { title: 'Login', path: '/login' },
    { title: 'Sign Up', path: '/signup' }
  ],
  auth: [
    { title: 'Logout', path: '/logout' },
    { title: 'Profile', path: '/profile' }
  ]
};

export default subMenuItems;
